import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AmplifyAuthService } from '../services/auth/amplify-auth.service';
import { RumInitializerService } from '../services/rum/rum-initializer.service';

export const appInterceptor: HttpInterceptorFn = (req, next) => {
  const amplifyAuthService = inject(AmplifyAuthService);
  const rumService = inject(RumInitializerService);
  const isMainApiRequest = req.url.includes(environment.urlBase);
  const isPersonaApiRequest = req.url.includes(environment.apiPersonaAWS);

  if (isMainApiRequest) {
    const appToken = environment.appToken;

    if (!appToken) {
      rumService.recordError(new Error(`No hay appToken disponible para: ${req.url}`));
    }

    const modifiedRequest = req.clone({
      setHeaders: {
        Authorization: appToken ? `Bearer ${appToken}` : ''
      }
    });

    return next(modifiedRequest);
  }

  if (isPersonaApiRequest) {
    return from(amplifyAuthService.getAccessToken()).pipe(
      switchMap(accessToken => {
        if (!accessToken) {
          return throwError(() => new Error('No authentication token available for AWS API'));
        }

        const modifiedRequest = req.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` }
        });

        return next(modifiedRequest);
      })
    );
  }

  return next(req);
};
